import { render, staticRenderFns } from "./ApproversAssigned.vue?vue&type=template&id=8aca4fe8&scoped=true&"
import script from "./ApproversAssigned.vue?vue&type=script&lang=ts&"
export * from "./ApproversAssigned.vue?vue&type=script&lang=ts&"
import style0 from "./ApproversAssigned.vue?vue&type=style&index=0&id=8aca4fe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aca4fe8",
  null
  
)

export default component.exports